var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApartment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 61,
    viewBox: "0 0 59 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0818 59.1091H14.3789V3.42188H48.0818V59.1091Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.406 1H12.0544V3.42118H50.406V1Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4376 45.793C29.7306 45.793 28.325 47.2572 28.325 49.0353V58.7621H34.5502V49.0353C34.5502 47.2572 33.1445 45.793 31.4376 45.793Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0005 15.5292H20.1897V11.1545C20.1897 9.50373 21.4992 8.26562 23.0542 8.26562C24.691 8.26562 25.9187 9.58627 25.9187 11.1545V15.5292H26.0005Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2708 15.5292H36.46V11.1545C36.46 9.50373 37.7694 8.26562 39.3245 8.26562C40.9613 8.26562 42.189 9.58627 42.189 11.1545V15.5292H42.2708Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0005 28.8417H20.1897V24.467C20.1897 22.8162 21.4992 21.5781 23.0542 21.5781C24.691 21.5781 25.9187 22.8988 25.9187 24.467V28.8417H26.0005Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2708 28.8417H36.46V24.467C36.46 22.8162 37.7694 21.5781 39.3245 21.5781C40.9613 21.5781 42.189 22.8988 42.189 24.467V28.8417H42.2708Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0005 42.162H20.1897V37.7874C20.1897 36.1365 21.4992 34.8984 23.0542 34.8984C24.691 34.8984 25.9187 36.2191 25.9187 37.7874V42.162H26.0005Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2708 42.162H36.46V37.7874C36.46 36.1365 37.7694 34.8984 39.3245 34.8984C40.9613 34.8984 42.189 36.2191 42.189 37.7874V42.162H42.2708Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartment);
export default __webpack_public_path__ + "static/media/apartment.80deb799adbcc938d73267d7131d3e9a.svg";
export { ForwardRef as ReactComponent };